/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/productManage',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '自营-商品管理',
      icon: 'component',
    },
    children: [
      {
        path: '/productManage/searchOperations',
        component: () => import('@/myviews/shoppMall/productManage/searchOperations/searchOperations.vue'),
        name: 'searchOperations',
        meta: {
          alwaysShow: false,
          title: '搜索运营',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/mayHelp',
        component: () => import('@/myviews/shoppMall/productManage/mayHelp/mayHelpList.vue'),
        name: 'mayHelp',
        meta: {
          alwaysShow: false,
          title: '自营-可能帮到你',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/goodsChannelList', //新增自营
        component: () => import('@/myviews/shoppMall/productManage/goodsChannelList/goodsChannelList.vue'),
        alwaysShow: false,
        name: 'goodsChannelList',
        meta: {
          title: '自营商品列表',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/presaleProductList', //预售商品列表
        component: () => import('@/myviews/shoppMall/productManage/presaleProductList/presaleProductList.vue'),
        alwaysShow: false,
        name: 'presaleProductList',
        meta: {
          title: '预售商品列表',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/batchOperation', //批量操作
        component: () => import('@/myviews/shoppMall/productManage/batchOperation/batchOperationList.vue'),
        alwaysShow: false,
        name: 'batchOperation',
        hidden: true,
        meta: {
          title: '批量操作',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/productManualList',
        component: () => import('@/myviews/shoppMall/productManage/productManualList/productManualList.vue'),
        name: 'productManualList',
        meta: {
          alwaysShow: false,
          title: '产品说明书列表',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/productInforList',
        component: () => import('@/myviews/shoppMall/productManage/productInforList/productInforList.vue'),
        alwaysShow: false,
        name: 'ProductInforList',
        meta: {
          title: '商品信息列表',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/virtualGoodsAdd',
        component: () => import('@/myviews/shoppMall/productManage/productInforList/components/virtualGoodsAdd.vue'),
        name: 'VirtualGoodsAdd',
        hidden: true,
        meta: {
          alwaysShow: false,
          title: '虚拟商品',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/productStockList',
        component: () => import('@/myviews/shoppMall/productManage/productStockList/productStockList.vue'),
        alwaysShow: false,
        name: 'productStockList',
        meta: {
          title: '商品库存列表',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/productChannelList',
        component: () => import('@/myviews/shoppMall/productManage/productChannelList/productChannelList.vue'),
        alwaysShow: false,
        name: 'ProductChannelList',
        meta: {
          title: '商品渠道列表',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/addChannelProduct', //新增自营
        component: () => import('@/myviews/shoppMall/productManage/goodsChannelList/components/addChannelProduct.vue'),
        hidden: true,
        name: 'addChannelProduct',
        meta: {
          title: '新增渠道商品',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/channelCombination',
        component: () => import('@/myviews/shoppMall/productManage/productChannelList/components/channelCombination.vue'),
        hidden: true,
        name: 'ChannelCombination',
        meta: {
          title: '渠道商品',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/labelManage',
        component: () => import('@/myviews/shoppMall/productManage/labelManage/labelManage.vue'),
        alwaysShow: false,
        name: 'labelManage',
        meta: {
          title: '自营-标签管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/commonNameManage',
        component: () => import('@/myviews/shoppMall/productManage/commonNameManage/commonNameManageList.vue'),
        alwaysShow: false,
        name: 'commonNameManage',
        meta: {
          title: '自营-通用名管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/productLabelManage',
        component: () => import('@/myviews/shoppMall/productManage/productLabelManage/productLabelManage.vue'),
        alwaysShow: false,
        name: 'ProductLabelManage',
        meta: {
          title: '商品标签管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/shoppMall/shopTypeManage',
        component: () => import('@/myviews/shoppMall/productManage/shopTypeManage/shopTypeManage.vue'),
        alwaysShow: false,
        name: 'shopTypeManage',
        meta: {
          title: '商品分类管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/shoppMall/storehouseManage',
        component: () => import('@/myviews/shoppMall/productManage/storehouseManage/storehouseManage.vue'),
        alwaysShow: false,
        name: 'storehouseManage',
        meta: {
          title: '仓库管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },

      {
        path: '/productManage/prescriptionManage',
        component: () => import('@/myviews/shoppMall/productManage/prescriptionManage/prescriptionManage.vue'),
        name: 'prescriptionManage',
        meta: {
          alwaysShow: false,
          title: '处方药管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/deliverytime',
        component: () => import('@/myviews/shoppMall/productManage/deliverytime/deliverytimeManage.vue'),
        name: 'deliverytime',
        meta: {
          alwaysShow: false,
          title: '自营-发货时间',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },

      {
        path: '/productManage/evaluateList',
        component: () => import('@/myviews/shoppMall/productManage/productEvaluateList/productEvaluateList.vue'),
        alwaysShow: false,
        name: 'productEvaluateList',
        meta: {
          title: '商品评价',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },

      },
      {
        path: '/productManage/evaluateList/detail/:id',
        component: () => import('@/myviews/shoppMall/productManage/productEvaluateList/productEvaluateDetail.vue'),
        name: 'productEvaluateDetail',
        hidden: true, // 不是菜单项
        meta: {
          alwaysShow: false,
          title: '评价详情',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/productManage/specificationManage',
        component: () => import('@/myviews/shoppMall/productManage/specificationManage/specificationManageList.vue'),
        alwaysShow: false,
        name: 'specificationManageList',
        meta: {
          title: '商品规格管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/refundReasonManage/list',
        component: () => import('@/myviews/shoppMall/orderManage/refundReasonManage/list'),
        name: 'refundReasonManageList',
        meta: {
          title: '退款原因管理',
          icon: 'component',
          alwaysShow: false,
          roles: [],
          have: [],
        }
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/shoppMall/productManage.js